/**
 *
 * VideoPlayerProgress
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import { formatDuration } from 'components/VideoPlayer/helpers';

import VideoPlayerProgressBar from './styles/VideoPlayerProgressBar';
import VideoPlayerProgressTime from './styles/VideoPlayerProgressTime';
import VideoPlayerProgressIndicator from './styles/VideoPlayerProgressIndicator';
import VideoPlayerProgressWrapper from './styles/VideoPlayerProgressWrapper';

function formatElapsed(event, element, duration) {
  const { clientX, touches } = event;

  if (!element) return;

  const progressRect = element.getBoundingClientRect();
  const progressAmt = touches && touches[0] && touches[0].clientX ? touches[0].clientX  - progressRect.left: clientX - progressRect.left;

  const progressPosition = duration * Math.min(1, Math.max(0, progressAmt / progressRect.width))
  if (typeof progressPosition === 'number') return progressPosition;
}

class VideoPlayerProgress extends React.Component {
  constructor() {
    super();

    this.state = {
      transitionDisabled: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleProgressClick = this.handleProgressClick.bind(this);
    this.unbindMouseListeners = this.unbindMouseListeners.bind(this);
  }

  handleProgressClick(event) {

    event.persist();

    const { isLive } = this.props;

    if (isLive) return;

    this.setState({ transitionDisabled: true });

    this.handleChange(event);
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('touchmove', this.handleMouseMove);
    window.addEventListener('touchend', this.handleMouseUp);    
    window.addEventListener('mouseup', this.handleMouseUp);
  }

  handleChange(event) {
    const { duration } = this.props;

    const elapsed = formatElapsed(event, this.progress, duration);

    if (elapsed) this.props.onChangeProgress(elapsed);
  }

  handleMouseMove(event) {
    const { duration } = this.props;

    const elapsed = formatElapsed(event, this.progress, duration);

    if (elapsed) this.props.onChangeProgress(elapsed);
  }

  handleMouseUp() {
    this.unbindMouseListeners();
    this.setState({ transitionDisabled: false });
  }

  unbindMouseListeners() {
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('touchmove', this.handleMouseMove);
    window.removeEventListener('touchend', this.handleMouseUp);  
    window.removeEventListener('mouseup', this.handleMouseUp);
  }

  render() {
    const { currentTime, duration, isLive } = this.props;
    const { transitionDisabled } = this.state;

    const progress = (currentTime / duration) * 100;

    return (
      <VideoPlayerProgressWrapper
        onMouseDown={this.handleProgressClick}
        onTouchStart={this.handleProgressClick}
        ref={node => (this.progress = node)}
      >
        <VideoPlayerProgressBar
          $isLive={isLive}
          style={
            {
              width: `${progress || 0}%`
            }
          }
          $transitionDisabled={transitionDisabled}
        >
          {!isLive && (
            <VideoPlayerProgressTime>
              {formatDuration(currentTime)}
            </VideoPlayerProgressTime>
          )}
          <VideoPlayerProgressIndicator isLive={isLive} />
        </VideoPlayerProgressBar>
      </VideoPlayerProgressWrapper>
    );
  }
}

VideoPlayerProgress.propTypes = {
  currentTime: PropTypes.number,
  duration: PropTypes.number,
  onChangeProgress: PropTypes.func
};

export default VideoPlayerProgress;
